import {
    Group,
    Stack,
} from '@mantine/core'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'
import { ManageEntities } from './manage-entities';
import PrimaryInput from 'app/views/components/buttons/PrimaryInput';
import React, { useState } from 'react'
import MultiPartForm from './multipart-form-modal';
import { useDispatch, useSelector } from 'react-redux';
import { loadEntityFormLists } from 'app/state/utils/form-lists';
import { getEntityScreenRows } from 'app/state/ducks/entity-screen/selectors';
import { EntitySearch } from 'app/views/components/search/entity-search';
import { EntityScreenRow } from 'app/models/entity-screen-row';



interface props {
    tab: string
}

export function EntitiesDrillPage({ tab }: props) {
    const dispatch = useDispatch()
    const [openEntity, setOpenEntity] = useState(false)
    const [loadingLists, setLoadingLists] = useState(false)
    // The search looks through the grid's own rows: the page loads nothing
    // else on arrival (the grid reads its one request itself).
    const entities: EntityScreenRow[] = useSelector(getEntityScreenRows)

    // The form builds its dropdowns once, on mount, from the store: it opens
    // behind a loader until the lists it reads have landed.
    const openCreateEntity = async () => {
        if (loadingLists) return
        setOpenEntity(true)
        setLoadingLists(true)
        try {
            await dispatch(loadEntityFormLists() as any)
        } finally {
            setLoadingLists(false)
        }
    }

    const tabs: { [key in props['tab']]: { route: string; label: string; active: boolean; pageRender: JSX.Element; } } = {
        entities: { route: `/entitymanagement`, label: 'ENTITIES', active: tab === 'entities' ? true : false, pageRender: <ManageEntities /> },
    }
    return (
        <Stack w="100%">
            {openEntity && <MultiPartForm setOpen={setOpenEntity} open={openEntity} loading={loadingLists} />}
            <Group w="100%" position="apart" className='tabsGapsActivityWithEntitySearch'>
                <Group>
                    <SegmentControlUpdated tabs={tabs} />
                </Group>
                <Group noWrap className="searchActionsGroup" align="center">
                    <EntitySearch
                        data={entities}
                        placeholder="Entity Search"
                    />
                    <PrimaryInput onClick={openCreateEntity} text="Create Entity" />
                </Group>
            </Group>
            {tabs[tab].pageRender}
        </Stack>
    )
}